module.exports = __webpack_public_path__ + "static/media/how_to_use_5.16dcd770.png";